import { Injectable } from '@angular/core'
import { GiphyFetch } from '@giphy/js-fetch-api'
import { GiphySticker } from 'src/app/interfaces/giphy'
import { LocaleCode } from 'src/app/interfaces/locale'
import { environment } from 'src/environments/environment'
import { LocaleService } from '../locale/locale-service'

@Injectable({
  providedIn: 'root',
})
export class GiphyService {
  constructor(private localeService: LocaleService) {}
  private gf = new GiphyFetch(environment.giphyApiKey)

  async search(search: string, offset: number, pageSize: number = 20): Promise<GiphySticker[]> {
    const lang = this.localeService.locale === LocaleCode.ko ? 'ko' : 'en'
    const { data } = await this.gf.search(search, { sort: 'relevant', lang, offset, limit: pageSize, type: 'stickers' })
    return data.map((gif) => ({ id: gif.id, url: gif.images.downsized.url }))
  }
}
